module.exports = __webpack_public_path__ + "assets/img/28.4fcd639f.png";